import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { PageComponent } from './components/page/page.component';
import { SharedModule } from '../../../shared/shared.module';
import { ProyectosRoutingModule } from './proyectos-routing.module';
import { AllocateResourcesComponent } from './components/allocate-resources/allocate-resources.component';

@NgModule({
	declarations: [PageComponent, AllocateResourcesComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		SharedModule,
		ProyectosRoutingModule,
	],
})
export class ProyectosModule { }
